﻿export const openDayTime: object = {
  opendaytimeFormat: "{0}: {1}",
  opendaytimeSeperator: "\r\n",
  opentimeFormat: "HH:mm",
  opentimeFormatSmart: "H",
  opentimeCombine: "{0} - {1} o'clock",
  opentimeCombineWithoutColockLabel: "{0} - {1}",
  opendayCombine: "{0} - {1}",
  opentimeSeperator: ",\r\n",
  weekdayMarker: ">> {0} <<",

  phClosed: "closed",
  phMondayFull: "Monday",
  phMonday: "Mo.",
  phTuesdayFull: "Tuesday",
  phTuesday: "Tu.",
  phWednesdayFull: "Wednesday",
  phWednesday: "We.",
  phThursdayFull: "Thursday",
  phThursday: "Th.",
  phFridayFull: "Friday",
  phFriday: "Fr.",
  phSaturdayFull: "Saturday",
  phSaturday: "Sa.",
  phSundayFull: "Sunday",
  phSunday: "Su."
};
